// taken from https://github.com/zachleat/font-family-reunion/blob/master/test/src/font-families.json
export const fontFamilies = [
  "Arial",
  "monospace",
  "Comic Sans MS",
  "Brush Script MT",
  "Luminari, fantasy",
  "Arial Narrow, sans-serif",
];
